var map = {
	"./img_1.jpg": 28436,
	"./img_10.jpg": 20481,
	"./img_11.jpg": 81781,
	"./img_2.jpg": 41516,
	"./img_3.jpg": 85704,
	"./img_4.jpg": 56143,
	"./img_5.jpg": 46247,
	"./img_6.jpg": 39374,
	"./img_7.jpg": 26541,
	"./img_8.jpg": 59960,
	"./img_9.jpg": 66868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23425;